/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useMutation, useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  BulkUserLinksDto,
  ChangeMyPasswordDto,
  CreateUserDto,
  DataEnvelopeOfBulkUserLinksResultDto,
  DataEnvelopeOfInvitationResultDto,
  DataEnvelopeOfObject,
  DataEnvelopeOfUserDto,
  DataPaginationEnvelopeOfUserDto,
  ErrorEnvelope,
  GetAllUsersParams,
  InviteUserDto,
  UpdateMyProfileDto,
  UpdateUserDto,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

/**
 * @summary Obtém perfil do usuário autenticado
 */
export const getMe = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
  return customInstance<DataEnvelopeOfUserDto>(
    { url: `/v1/users/me`, method: 'GET', signal },
    options,
  )
}

export const getGetMeQueryKey = () => {
  return [`/v1/users/me`] as const
}

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorEnvelope,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>
  request?: SecondParameter<typeof customInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) =>
    getMe(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorEnvelope

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorEnvelope>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorEnvelope>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorEnvelope>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Obtém perfil do usuário autenticado
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorEnvelope>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const updateMyProfile = (
  updateMyProfileDto: UpdateMyProfileDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfUserDto>(
    {
      url: `/v1/users/me`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateMyProfileDto,
      signal,
    },
    options,
  )
}

export const getUpdateMyProfileMutationKey = () => ['updateMyProfile'] as const

export const getUpdateMyProfileMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyProfile>>,
    TError,
    UpdateMyProfileMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyProfile>>,
  TError,
  UpdateMyProfileMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateMyProfileMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyProfile>>,
    UpdateMyProfileMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return updateMyProfile(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateMyProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateMyProfile>>>
export type UpdateMyProfileMutationBody = UpdateMyProfileDto
export type UpdateMyProfileMutationError = unknown
export type UpdateMyProfileMutationVariables = { data: UpdateMyProfileDto }

export const useUpdateMyProfile = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMyProfile>>,
      TError,
      UpdateMyProfileMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMyProfile>>,
  TError,
  UpdateMyProfileMutationVariables,
  TContext
> => {
  return useMutation(getUpdateMyProfileMutationOptions(options), queryClient)
}
/**
 * @summary Lista todos os usuários (Admin)
 */
export const getAllUsers = (
  params?: GetAllUsersParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataPaginationEnvelopeOfUserDto>(
    { url: `/v1/users`, method: 'GET', params, signal },
    options,
  )
}

export const getGetAllUsersQueryKey = (params?: GetAllUsersParams) => {
  return [`/v1/users`, ...(params ? [params] : [])] as const
}

export const getGetAllUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllUsers>>,
  TError = ErrorEnvelope,
>(
  params?: GetAllUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAllUsersQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllUsers>>> = ({ signal }) =>
    getAllUsers(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getAllUsers>>>
export type GetAllUsersQueryError = ErrorEnvelope

export function useGetAllUsers<
  TData = Awaited<ReturnType<typeof getAllUsers>>,
  TError = ErrorEnvelope,
>(
  params: undefined | GetAllUsersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllUsers>>,
          TError,
          Awaited<ReturnType<typeof getAllUsers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllUsers<
  TData = Awaited<ReturnType<typeof getAllUsers>>,
  TError = ErrorEnvelope,
>(
  params?: GetAllUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllUsers>>,
          TError,
          Awaited<ReturnType<typeof getAllUsers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllUsers<
  TData = Awaited<ReturnType<typeof getAllUsers>>,
  TError = ErrorEnvelope,
>(
  params?: GetAllUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista todos os usuários (Admin)
 */

export function useGetAllUsers<
  TData = Awaited<ReturnType<typeof getAllUsers>>,
  TError = ErrorEnvelope,
>(
  params?: GetAllUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAllUsersQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Cria novo usuário (Admin)
 */
export const createUser = (
  createUserDto: CreateUserDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfUserDto>(
    {
      url: `/v1/users`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUserDto,
      signal,
    },
    options,
  )
}

export const getCreateUserMutationKey = () => ['createUser'] as const

export const getCreateUserMutationOptions = <TError = ErrorEnvelope, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUser>>,
    TError,
    CreateUserMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUser>>,
  TError,
  CreateUserMutationVariables,
  TContext
> => {
  const mutationKey = getCreateUserMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUser>>,
    CreateUserMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return createUser(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
export type CreateUserMutationBody = CreateUserDto
export type CreateUserMutationError = ErrorEnvelope
export type CreateUserMutationVariables = { data: CreateUserDto }

/**
 * @summary Cria novo usuário (Admin)
 */
export const useCreateUser = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createUser>>,
      TError,
      CreateUserMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createUser>>,
  TError,
  CreateUserMutationVariables,
  TContext
> => {
  return useMutation(getCreateUserMutationOptions(options), queryClient)
}
/**
 * @summary Obtém usuário por ID (Admin)
 */
export const getUserById = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfUserDto>(
    { url: `/v1/users/${id}`, method: 'GET', signal },
    options,
  )
}

export const getGetUserByIdQueryKey = (id: string) => {
  return [`/v1/users/${id}`] as const
}

export const getGetUserByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError = ErrorEnvelope,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetUserByIdQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserById>>> = ({ signal }) =>
    getUserById(id, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetUserByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserById>>>
export type GetUserByIdQueryError = ErrorEnvelope

export function useGetUserById<
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError = ErrorEnvelope,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserById>>,
          TError,
          Awaited<ReturnType<typeof getUserById>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserById<
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError = ErrorEnvelope,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserById>>,
          TError,
          Awaited<ReturnType<typeof getUserById>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserById<
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError = ErrorEnvelope,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Obtém usuário por ID (Admin)
 */

export function useGetUserById<
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError = ErrorEnvelope,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserByIdQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Atualiza usuário (Admin)
 */
export const updateUser = (
  id: string,
  updateUserDto: UpdateUserDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfUserDto>(
    {
      url: `/v1/users/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateUserDto,
      signal,
    },
    options,
  )
}

export const getUpdateUserMutationKey = () => ['updateUser'] as const

export const getUpdateUserMutationOptions = <TError = ErrorEnvelope, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUser>>,
    TError,
    UpdateUserMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUser>>,
  TError,
  UpdateUserMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateUserMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUser>>,
    UpdateUserMutationVariables
  > = (props) => {
    const { id, data } = props ?? {}

    return updateUser(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
export type UpdateUserMutationBody = UpdateUserDto
export type UpdateUserMutationError = ErrorEnvelope
export type UpdateUserMutationVariables = { id: string; data: UpdateUserDto }

/**
 * @summary Atualiza usuário (Admin)
 */
export const useUpdateUser = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateUser>>,
      TError,
      UpdateUserMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateUser>>,
  TError,
  UpdateUserMutationVariables,
  TContext
> => {
  return useMutation(getUpdateUserMutationOptions(options), queryClient)
}
/**
 * @summary Remove usuário (Admin)
 */
export const deleteUser = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    { url: `/v1/users/${id}`, method: 'DELETE', signal },
    options,
  )
}

export const getDeleteUserMutationKey = () => ['deleteUser'] as const

export const getDeleteUserMutationOptions = <TError = ErrorEnvelope, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUser>>,
    TError,
    DeleteUserMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  DeleteUserMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteUserMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUser>>,
    DeleteUserMutationVariables
  > = (props) => {
    const { id } = props ?? {}

    return deleteUser(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>

export type DeleteUserMutationError = ErrorEnvelope
export type DeleteUserMutationVariables = { id: string }

/**
 * @summary Remove usuário (Admin)
 */
export const useDeleteUser = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteUser>>,
      TError,
      DeleteUserMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  DeleteUserMutationVariables,
  TContext
> => {
  return useMutation(getDeleteUserMutationOptions(options), queryClient)
}
export const inviteUser = (
  inviteUserDto: InviteUserDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfInvitationResultDto>(
    {
      url: `/v1/users/invitations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: inviteUserDto,
      signal,
    },
    options,
  )
}

export const getInviteUserMutationKey = () => ['inviteUser'] as const

export const getInviteUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteUser>>,
    TError,
    InviteUserMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof inviteUser>>,
  TError,
  InviteUserMutationVariables,
  TContext
> => {
  const mutationKey = getInviteUserMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof inviteUser>>,
    InviteUserMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return inviteUser(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type InviteUserMutationResult = NonNullable<Awaited<ReturnType<typeof inviteUser>>>
export type InviteUserMutationBody = InviteUserDto
export type InviteUserMutationError = unknown
export type InviteUserMutationVariables = { data: InviteUserDto }

export const useInviteUser = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof inviteUser>>,
      TError,
      InviteUserMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof inviteUser>>,
  TError,
  InviteUserMutationVariables,
  TContext
> => {
  return useMutation(getInviteUserMutationOptions(options), queryClient)
}
export const resendUserInvitation = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfInvitationResultDto>(
    { url: `/v1/users/${id}/invitation`, method: 'POST', signal },
    options,
  )
}

export const getResendUserInvitationMutationKey = () => ['resendUserInvitation'] as const

export const getResendUserInvitationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendUserInvitation>>,
    TError,
    ResendUserInvitationMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendUserInvitation>>,
  TError,
  ResendUserInvitationMutationVariables,
  TContext
> => {
  const mutationKey = getResendUserInvitationMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendUserInvitation>>,
    ResendUserInvitationMutationVariables
  > = (props) => {
    const { id } = props ?? {}

    return resendUserInvitation(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ResendUserInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendUserInvitation>>
>

export type ResendUserInvitationMutationError = unknown
export type ResendUserInvitationMutationVariables = { id: string }

export const useResendUserInvitation = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resendUserInvitation>>,
      TError,
      ResendUserInvitationMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resendUserInvitation>>,
  TError,
  ResendUserInvitationMutationVariables,
  TContext
> => {
  return useMutation(getResendUserInvitationMutationOptions(options), queryClient)
}
export const requestUserPasswordRecovery = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    { url: `/v1/users/${id}/password-recovery`, method: 'POST', signal },
    options,
  )
}

export const getRequestUserPasswordRecoveryMutationKey = () =>
  ['requestUserPasswordRecovery'] as const

export const getRequestUserPasswordRecoveryMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUserPasswordRecovery>>,
    TError,
    RequestUserPasswordRecoveryMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestUserPasswordRecovery>>,
  TError,
  RequestUserPasswordRecoveryMutationVariables,
  TContext
> => {
  const mutationKey = getRequestUserPasswordRecoveryMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestUserPasswordRecovery>>,
    RequestUserPasswordRecoveryMutationVariables
  > = (props) => {
    const { id } = props ?? {}

    return requestUserPasswordRecovery(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type RequestUserPasswordRecoveryMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestUserPasswordRecovery>>
>

export type RequestUserPasswordRecoveryMutationError = unknown
export type RequestUserPasswordRecoveryMutationVariables = { id: string }

export const useRequestUserPasswordRecovery = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof requestUserPasswordRecovery>>,
      TError,
      RequestUserPasswordRecoveryMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof requestUserPasswordRecovery>>,
  TError,
  RequestUserPasswordRecoveryMutationVariables,
  TContext
> => {
  return useMutation(getRequestUserPasswordRecoveryMutationOptions(options), queryClient)
}
export const changeMyPassword = (
  changeMyPasswordDto: ChangeMyPasswordDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    {
      url: `/v1/users/me/password`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: changeMyPasswordDto,
      signal,
    },
    options,
  )
}

export const getChangeMyPasswordMutationKey = () => ['changeMyPassword'] as const

export const getChangeMyPasswordMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeMyPassword>>,
    TError,
    ChangeMyPasswordMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeMyPassword>>,
  TError,
  ChangeMyPasswordMutationVariables,
  TContext
> => {
  const mutationKey = getChangeMyPasswordMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeMyPassword>>,
    ChangeMyPasswordMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return changeMyPassword(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ChangeMyPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeMyPassword>>
>
export type ChangeMyPasswordMutationBody = ChangeMyPasswordDto
export type ChangeMyPasswordMutationError = unknown
export type ChangeMyPasswordMutationVariables = { data: ChangeMyPasswordDto }

export const useChangeMyPassword = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changeMyPassword>>,
      TError,
      ChangeMyPasswordMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof changeMyPassword>>,
  TError,
  ChangeMyPasswordMutationVariables,
  TContext
> => {
  return useMutation(getChangeMyPasswordMutationOptions(options), queryClient)
}
export const revokeMySessions = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    { url: `/v1/users/me/revoke-sessions`, method: 'POST', signal },
    options,
  )
}

export const getRevokeMySessionsMutationKey = () => ['revokeMySessions'] as const

export const getRevokeMySessionsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeMySessions>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<Awaited<ReturnType<typeof revokeMySessions>>, TError, void, TContext> => {
  const mutationKey = getRevokeMySessionsMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeMySessions>>, void> = () => {
    return revokeMySessions(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type RevokeMySessionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeMySessions>>
>

export type RevokeMySessionsMutationError = unknown

export const useRevokeMySessions = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof revokeMySessions>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof revokeMySessions>>, TError, void, TContext> => {
  return useMutation(getRevokeMySessionsMutationOptions(options), queryClient)
}
/**
 * @summary Adiciona vínculos em lote sem remover vínculos existentes (Admin)
 */
export const addUserLinksBulk = (
  bulkUserLinksDto: BulkUserLinksDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfBulkUserLinksResultDto>(
    {
      url: `/v1/users/links/bulk`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: bulkUserLinksDto,
      signal,
    },
    options,
  )
}

export const getAddUserLinksBulkMutationKey = () => ['addUserLinksBulk'] as const

export const getAddUserLinksBulkMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addUserLinksBulk>>,
    TError,
    AddUserLinksBulkMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof addUserLinksBulk>>,
  TError,
  AddUserLinksBulkMutationVariables,
  TContext
> => {
  const mutationKey = getAddUserLinksBulkMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addUserLinksBulk>>,
    AddUserLinksBulkMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return addUserLinksBulk(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AddUserLinksBulkMutationResult = NonNullable<
  Awaited<ReturnType<typeof addUserLinksBulk>>
>
export type AddUserLinksBulkMutationBody = BulkUserLinksDto
export type AddUserLinksBulkMutationError = ErrorEnvelope
export type AddUserLinksBulkMutationVariables = { data: BulkUserLinksDto }

/**
 * @summary Adiciona vínculos em lote sem remover vínculos existentes (Admin)
 */
export const useAddUserLinksBulk = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addUserLinksBulk>>,
      TError,
      AddUserLinksBulkMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addUserLinksBulk>>,
  TError,
  AddUserLinksBulkMutationVariables,
  TContext
> => {
  return useMutation(getAddUserLinksBulkMutationOptions(options), queryClient)
}
